var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"page",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[(_vm.passenger)?_c('PassengerEdit',{attrs:{"passenger":_vm.passenger},on:{"close":_vm.onClose}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }